var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateApplicationsList = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 260,
    viewBox: "0 0 400 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.301 187.659C131.698 185.979 130.657 184.296 128.977 183.899C127.297 183.503 125.614 184.543 125.217 186.223C124.821 187.904 125.861 189.587 127.541 189.984C129.221 190.38 130.905 189.34 131.301 187.659Z",
    fill: "#071A24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M357.903 185.79C358.299 184.11 357.259 182.427 355.579 182.03C353.899 181.634 352.215 182.674 351.819 184.354C351.422 186.035 352.463 187.718 354.143 188.115C355.823 188.511 357.506 187.471 357.903 185.79Z",
    fill: "#071A24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.596 57.52C261.605 57.758 262.229 58.7683 261.991 59.7766C261.753 60.7849 260.743 61.4093 259.735 61.1714C258.726 60.9334 258.102 59.9231 258.34 58.9148C258.578 57.9065 259.588 57.2821 260.596 57.52Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4695 37.0615C41.0305 37.6498 40.6899 38.3343 40.4157 39.127C40.1415 38.3343 39.8009 37.6498 39.3619 37.0615C38.7142 36.1937 37.901 35.5948 36.93 35.1408C37.901 34.6868 38.7142 34.0879 39.3619 33.2201C39.8009 32.6318 40.1415 31.9473 40.4157 31.1545C40.6899 31.9473 41.0305 32.6318 41.4695 33.2201C42.1172 34.0879 42.9304 34.6868 43.9014 35.1408C42.9304 35.5948 42.1172 36.1937 41.4695 37.0615Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.056 207.595L153.057 207.595L153.056 207.595ZM162.815 202.389C164.341 200.345 165.247 197.599 165.92 193.835C166.594 197.599 167.5 200.345 169.026 202.389C170.755 204.706 173.171 205.988 176.457 206.973C173.171 207.958 170.755 209.24 169.026 211.557C167.5 213.601 166.594 216.348 165.92 220.112C165.247 216.348 164.341 213.601 162.815 211.557C161.086 209.24 158.67 207.958 155.384 206.973C158.67 205.988 161.086 204.706 162.815 202.389Z",
    fill: "#4767FF",
    stroke: "#4767FF",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M378.691 169.172C372.015 170.784 370.415 172.78 369.286 181.926C369.221 182.461 368.444 182.461 368.379 181.926C367.249 172.78 365.65 170.788 358.973 169.172C358.508 169.059 358.508 168.395 358.973 168.286C365.65 166.674 367.249 164.678 368.379 155.532C368.444 154.997 369.221 154.997 369.286 155.532C370.415 164.678 372.015 166.67 378.691 168.286C379.157 168.399 379.157 169.063 378.691 169.172Z",
    fill: "#071A24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.98 133.957H353.197C354.116 133.957 354.865 134.702 354.865 135.625V158.813C354.865 159.732 354.12 160.481 353.197 160.481H262.98C262.06 160.481 261.312 159.736 261.312 158.813V135.625C261.312 134.706 262.056 133.957 262.98 133.957Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M270.034 140.285H291.712C292.631 140.285 293.38 141.03 293.38 141.953V146.152C293.38 147.071 292.635 147.82 291.712 147.82H270.034C269.115 147.82 268.366 147.075 268.366 146.152V141.953C268.366 141.034 269.111 140.285 270.034 140.285Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M262.98 107.438H353.197C354.116 107.438 354.865 108.182 354.865 109.106V132.294C354.865 133.213 354.12 133.962 353.197 133.962H262.98C262.06 133.962 261.312 133.217 261.312 132.294V109.106C261.312 108.187 262.056 107.438 262.98 107.438Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.716 113.762H270.042C269.121 113.762 268.374 114.509 268.374 115.43V119.625C268.374 120.546 269.121 121.293 270.042 121.293H291.716C292.637 121.293 293.384 120.546 293.384 119.625V115.43C293.384 114.509 292.637 113.762 291.716 113.762Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M262.98 80.9141H353.197C354.116 80.9141 354.865 81.6591 354.865 82.5822V105.77C354.865 106.689 354.12 107.438 353.197 107.438H262.98C262.06 107.438 261.312 106.693 261.312 105.77V82.5822C261.312 81.6631 262.056 80.9141 262.98 80.9141Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M270.034 87.2422H291.712C292.631 87.2422 293.38 87.9872 293.38 88.9103V93.109C293.38 94.0281 292.635 94.7772 291.712 94.7772H270.034C269.115 94.7772 268.366 94.0322 268.366 93.109V88.9103C268.366 87.9912 269.111 87.2422 270.034 87.2422Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.836 160.032C182.69 148.44 167.211 158.955 162.551 153.586C155.983 146.015 192.383 136.605 183.605 126.487C177.357 119.28 156.303 124.584 156.303 124.584C145.908 127.118 123.86 130.665 118.827 124.584",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.47 161.733C315.745 165.021 312.818 167.48 309.314 167.48C305.811 167.48 302.886 165.021 302.159 161.733L316.47 161.733Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8787 63.6973L135.248 103.785L111.157 121.855L109.853 122.831L82.8388 143.1L47.6784 106.798L22.5225 81.6014L73.8787 63.6973Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.02 119.283L51.8662 77.5346L72.548 69.2344L125.435 103.735L104.02 119.283Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2334 97.7766L61.7121 91.2012L76.5432 104.105L62.1089 112.162L47.2334 97.7766Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2568 74.5684L110.601 114.503",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8662 71.5156L72.887 75.8884L79.7376 80.8645L86.722 85.9378L94.6011 91.6588L102.083 97.0965L109.704 102.631L118.328 108.895",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2568 82.3623L77.8697 73.5195",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9341 77.9414L79.7394 80.8647L72.5567 84.9095L65.8193 88.7034",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M116.548 97.9395L109.705 102.632L102.073 107.867L96.2021 111.892",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.689 92.8203L102.078 97.096L94.5103 101.991L87.9834 106.21",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.499 100.456L87.1838 96.2858L94.6013 91.6579L100.897 87.7305",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0303 94.4761L79.5935 90.3826L86.7235 85.937L92.562 82.293",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M115.844 51.5049C118.095 41.5405 115.864 38.6294 112.621 37.3824C109.483 36.1758 106.418 36.9329 103.054 45.7474L115.844 51.5049Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M108.687 50.9239C107.615 50.4189 106.463 50.5009 105.51 51.0352C104.573 51.5599 103.881 52.4839 103.548 53.6004L103.547 53.6044C103.167 54.8914 103.303 56.2771 103.856 57.4085L102.298 62.5802C102.298 62.5803 102.298 62.5804 102.298 62.5805C101.92 63.8297 102.369 65.4134 103.609 66.1006L103.612 66.1022C104.289 66.4746 105.062 66.485 105.722 66.1584C106.365 65.8404 106.811 65.2527 107.018 64.5758C107.018 64.5757 107.018 64.5756 107.018 64.5754L108.583 59.4847C109.603 59.0705 110.4 58.1875 110.823 57.0813L110.842 57.0615L110.931 56.775C111.611 54.5932 110.782 51.9086 108.687 50.9239ZM108.687 50.9239L108.155 52.0548L108.686 50.9234C108.687 50.9236 108.687 50.9237 108.687 50.9239ZM115.63 51.2304L120.596 53.4264L120.596 53.4281C120.595 53.4278 120.595 53.4276 120.595 53.4277C120.595 53.4278 120.636 53.4502 120.672 53.5426C120.71 53.6415 120.716 53.7652 120.678 53.879C120.678 53.8794 120.678 53.8798 120.678 53.8801L113.709 74.7265L94.0031 63.247C93.9961 63.2348 93.9866 63.2153 93.9774 63.1878C93.9469 63.0963 93.9453 62.9938 93.9657 62.9193C93.9658 62.9191 93.9658 62.9188 93.9659 62.9186L99.2261 43.9804L103.03 45.6629L103.03 45.6632L115.63 51.2302L115.63 51.2304Z",
    fill: "#071A24",
    stroke: "#071A24",
    strokeWidth: 2.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M160.921 40.3027L85.1866 16.1309L73.874 63.6972L135.243 103.737L160.921 40.3027Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M152.292 44.2235L88.8542 21.4121L78.8818 62.5083L132.525 94.8063L152.292 44.2235Z",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M120.935 114.988L109.671 124.406C112.307 127.317 116.793 127.661 119.834 125.119C122.874 122.576 123.336 118.102 120.935 114.992V114.988Z",
    fill: "#071A24"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M309.283 165.853C309.283 165.853 308.801 213.954 291.193 213.553C277.622 213.244 276.823 202.257 267.72 201.606C255.67 200.744 255.559 233.503 244.668 231.09C236.39 229.256 243.459 210.6 236.73 201.836C229.713 192.694 218.746 195.466 218.746 195.466",
    stroke: "#071A24",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.803 154.309C187.867 154.309 175.757 166.419 175.757 181.355C175.757 196.292 187.867 208.402 202.803 208.402C217.74 208.402 229.85 196.292 229.85 181.355C229.85 166.419 217.74 154.309 202.803 154.309ZM202.803 197.134C194.09 197.134 187.029 190.068 187.029 181.359C187.029 172.65 194.09 165.585 202.803 165.585C211.517 165.585 218.578 172.646 218.578 181.359C218.578 190.072 211.512 197.134 202.803 197.134Z",
    fill: "#4767FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.997 183.027C210.944 179.014 208.459 174.993 204.446 174.045C200.432 173.098 196.411 175.584 195.464 179.597C194.517 183.61 197.002 187.631 201.016 188.578C205.029 189.526 209.05 187.04 209.997 183.027Z",
    fill: "#4767FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M228.458 189.266L220.393 201.534C223.757 203.562 228.15 202.595 230.328 199.283C232.507 195.971 231.657 191.553 228.458 189.27V189.266Z",
    fill: "#4767FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M183.683 163.158L196.097 155.319C193.87 152.084 189.469 151.149 186.117 153.266C182.764 155.384 181.716 159.756 183.683 163.158Z",
    fill: "#4767FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateApplicationsList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateApplicationsList.870399483492c65cfbd96a274afd1848.svg";